/**
 * Global Postscript popup opener. Used by collection header CTA and product cards
 * when timer is active. Reads popup IDs from Theme or from element data attributes.
 */
class PostscriptPopup {
  static MOBILE_BREAKPOINT = 768;

  static POPUP_OPTIONS = {
    activePopupBehavior: "ALWAYS_DISMISS",
    respectPopupStatus: false,
  };

  /**
   * Strip surrounding quotes and parse as integer (handles ""123"" from Liquid/JSON).
   * @param {string|number|null|undefined} val
   * @returns {number|null}
   */
  static parsePopupId(val) {
    if (val == null) return null;
    if (typeof val === "number" && !Number.isNaN(val)) return val;
    const str = String(val)
      .trim()
      .replace(/^"+|"+$/g, "");
    if (!str) return null;
    const num = parseInt(str, 10);
    return Number.isNaN(num) ? null : num;
  }

  /**
   * @param {string|number|null} mobileId
   * @param {string|number|null} desktopId
   * @returns {number|null}
   */
  static getPopupId(mobileId, desktopId) {
    const isMobile = window.innerWidth < PostscriptPopup.MOBILE_BREAKPOINT;
    const idStr = isMobile ? mobileId || desktopId : desktopId || mobileId;
    return PostscriptPopup.parsePopupId(idStr);
  }

  /**
   * Open Postscript popup by mobile/desktop IDs (picks by viewport).
   * @param {string|number|null} mobileId
   * @param {string|number|null} desktopId
   */
  static open(mobileId, desktopId) {
    const id = PostscriptPopup.getPopupId(mobileId, desktopId);
    if (id != null && window.postscript && window.postscript.popups) {
      window.postscript.popups.open(id, PostscriptPopup.POPUP_OPTIONS);
    }
  }
}

window.openPostscriptPopup = PostscriptPopup.open.bind(PostscriptPopup);

/** @param {Event} event @param {HTMLElement} productCardEl */
window.handleProductCardTimerClick = function (event, productCardEl) {
  const theme = window.Theme;
  if (theme) {
    PostscriptPopup.open(theme.postscriptPopupIdMobile, theme.postscriptPopupIdDesktop);
  }
};
